import {RootStateOrAny, useSelector} from "react-redux";

export const useCustomSelector = (selector: string) => useSelector((state: RootStateOrAny) => state.get(selector).toJS());